module.exports = __webpack_public_path__ + "img/serviceGuide-business-1.7246b0c.png";